import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { IDashboardEngineius } from '../../interfaces/dashboard';
import { ITaskFilter } from '../../interfaces/task-filter';
import { ITaskInfo } from '../../interfaces/task-info';
import { DashboardService } from '../../services';
import { LoggerService } from '../../services';
import { TaggedLogger } from '../../services/taggedLogger';
import { TaskService } from '../../services';
import { flatten } from '../../utils/flatten';

@Component({
  selector: 'dashboard-engineius',
  styleUrls: ['./dashboard-engineius.component.css'],
  templateUrl: './dashboard-engineius.component.html',
})
export class DashboardEngineiusComponent implements OnInit {
  private logger: TaggedLogger;

  inboxType_VmeInbox = 1;
  inboxType_SupplierExistingJobs = 2;
  inboxType_CustomerInbox = 3;

  public inboxType_SupplierToBeConfirmed = 1;
  public inboxType_AwaitingStart = 2;
  public inboxType_CompletedJobs = 3;
  public inboxType_Combine = 4;
  public inboxType_JobsWaitingForApproval = 5;
  public inboxType_Live = 6;
  public inboxType_UrgentJobs = 7;
  public inboxType_ClosedJobs = 8;

  //stages (from vme inbox component)
  public stageHeld = 1;
  public stageBuyNow = 3;

  public subscription: Subscription;
  public tasksLive: any[];
  public tasksOffline: any[];
  public from: string;
  public to: string;
  public filterVal: ITaskFilter;

  public data: IDashboardEngineius = {};
  public onboarding: any = {};
  public onboardingOptions: any = {};

  public unallocatedOrders: any = {};
  public unallocatedOrdersOptions: any = {};

  public _selectedTask: ITaskInfo;

  private _isOfflineMode: boolean;
  set isOfflineMode(value: boolean) {
    this._isOfflineMode = value;

    this.filterVal.filters.isOfflineMode.value = value;
    this.refreshTasks();
  }
  get isOfflineMode(): boolean {
    return this._isOfflineMode;
  }

  constructor(
    private taskService: TaskService,
    private dashboardService: DashboardService,
    private router: Router,
    loggerService: LoggerService,
  ) {
    this.logger = loggerService.taggedLogger('DashboardEngineius');
  }

  ngOnInit() {
    this.initDefaultFilter();
    this.refreshTasks();
    // let timer = TimerObservable.create(0, 30000);
    // this.subscription = timer.subscribe(t => {
    //     this.refreshTasks();
    // });

    this.unallocatedOrdersOptions = {
      scaleShowValues: true,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              //stepSize: 1,
              autoSkip: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
          },
        ],
      },
    };

    this.onboardingOptions = {
      scaleShowValues: true,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              //stepSize: 1,
              autoSkip: true,
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              autoSkip: true,
            },
            gridLines: {
              display: true,
            },
          },
        ],
      },
    };

    this.dashboardService.getEngineius().then((result) => {
      this.data = result;

      this.unallocatedOrders = {
        labels: this.data.startingJobsHours,

        datasets: [
          {
            label: 'Planned',
            backgroundColor: 'red',
            borderColor: '#1E88E5',
            data: this.data.startingJobsPlanValues,
          },
          {
            label: 'Actual',
            backgroundColor: 'green',
            borderColor: '#1E88E5',
            data: this.data.startingJobsFactValues,
          },
        ],
      };

      this.onboarding = {
        labels: this.data.regRequestsDays,
        datasets: [
          {
            label: 'Supplier',
            backgroundColor: '#1976d2',
            borderColor: '#1E88E5',
            data: this.data.supplierRegRequestsValues,
          },
          {
            label: 'Customer',
            backgroundColor: 'green',
            borderColor: '#1E88E5',
            data: this.data.customerRegRequestsValues,
          },
        ],
      };
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: Number.MAX_SAFE_INTEGER / 2,
      sortField: '', // ASC
      sortOrder: 1,
      filters: {
        inboxType: { value: this.inboxType_VmeInbox },
        from: {},
        to: {},
        taskType: { value: 0 },
        eregionId: { value: 0 },
        isOfflineMode: { value: false },
        taskStep: { value: null },
        isDirectionsData: { value: true },
      },
    };
  }

  refreshTasks() {
    this.logger.trace('refreshTasks()');
    this.taskService.GetOfflineTasks(flatten(this.filterVal)).then((data) => {
      this.logger.debug('Got Offline Tasks:', data);
      if (!this.isOfflineMode) this.tasksLive = data.items;
      else this.tasksOffline = data.items;
      //this.myMap.vc.updateDirections();
      //this.myMap.map.triggerResize();
    });
  }

  goToInbox(event: Event, selectedInboxTab, stage = null) {
    event.preventDefault();
    if (stage) {
      return this.router.navigate(['/app/vmeinbox'], {
        queryParams: {
          selectedTab: selectedInboxTab,
          stageId: stage,
        },
      });
    }

    return this.router.navigate(['/app/vmeinbox'], {
      queryParams: {
        selectedTab: selectedInboxTab,
      },
    });
  }

  selectData(item) {
    console.log(this.router);
    this.router.navigate(['app/userrequests']);
  }

  taskClick(item) {
    this.router.navigate(['app/jobscreen/' + item.jobId]);
  }
}
